import { render, staticRenderFns } from "./GrowUpDialog.vue?vue&type=template&id=56fab822&scoped=true"
import script from "./GrowUpDialog.vue?vue&type=script&lang=js"
export * from "./GrowUpDialog.vue?vue&type=script&lang=js"
import style0 from "./GrowUpDialog.vue?vue&type=style&index=0&id=56fab822&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fab822",
  null
  
)

export default component.exports